/**
 * Helper
 */
var helper = require('../../helper');

$(function() {

    $('.datatable-property-notes').each(function () {
        let propertyId = $(this).data('property_id'),
            $datatable = $('#datatable-property-note-'+propertyId);
            console.log(propertyId);
            var table =   $datatable.DataTable({
            "dom": "<'dt-toolbar dt-toolbar-no-buttons'lf>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
            "processing": true,
            "serverSide": true,
            "responsive": true,
            "lengthMenu": [ 10, 50, 100],
            "ajax": helper.getOrigin() + "/api/notes/property/"+propertyId,
            "bAutoWidth" : false,
            "order": [[ 1, "desc" ]],
            "columns": [
                {data: 'id', name: 'id', visible: false},
                {data: 'created_at', name: 'company_name'},
                {data: 'user_name', name: 'user_name'},
                {data: 'type', name: 'type'},
                {data: 'content', name: 'content'},
                {
                    data: 'actions',
                    name: 'actions',
                    orderable: false,
                    searchable: false,
                    className : "action"
                }
            ]
        });

        $('#property_notes_btn').on( 'click',function (event) {
            event.preventDefault();
                    table
                         .column(3)
                           .search( 'property_note' )
                           .draw();
        });

        $('#fit_out_notes_btn').on( 'click',function (event) {
            event.preventDefault();
                    table
                         .column(3)
                           .search( 'fit_out_note' )
                           .draw();
        });

        $('#utilities_notes_btn').on( 'click',function (event) {
            event.preventDefault();
                    table
                         .column(3)
                           .search( 'utility_note' )
                           .draw();
        });

        $('#all_notes_btn').on( 'click',function (event) {
            event.preventDefault();
                    table
                         .column(3)
                           .search( '' )
                           .draw();
        });
                       
    });

   
        
});
